export default __webpack_public_path__ + "static/media/risk-result-5.e27b121d.svg";